import script from "./ironhedge_book.vue?vue&type=script&setup=true&lang=js"
export * from "./ironhedge_book.vue?vue&type=script&setup=true&lang=js"

import "./ironhedge_book.vue?vue&type=style&index=0&id=1d79afc6&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d79afc6"]])

export default __exports__